import { useState, useEffect } from 'react'

import { loadScript } from '@paypal/paypal-js'

import cspNonce from 'src/utils/cspNonce'
import { paypalCurrencySupported } from 'src/payments/paypalCurrency'

// `currency` must match what Summary.jsx passes — paypal-js reuses a cached
// script only on an exact URL match, so omitting it injected a second one.
const useVenmo = ({ enabled, paypalProps, currency }) => {
  const [ eligible, setEligible ] = useState(false)

  const clientId = paypalProps?.paypal?.client_id
  const sandbox = !!paypalProps?.paypal?.sandbox
  const supported = paypalCurrencySupported(currency, paypalProps?.currencies)

  const sandboxProps = enabled && sandbox ? { 'buyer-country': 'US' } : {}

  useEffect(() => {
    if (!enabled || !supported) return

    const checkEligibility = async () => {
      try {
        const paypal = await loadScript({
          'client-id': clientId,
          'data-csp-nonce': cspNonce(),
          'enable-funding': 'venmo',
          currency,
          ...(sandbox ? { 'buyer-country': 'US' } : {}),
        })

        const venmoEligible = paypal.Buttons({
          fundingSource: paypal.FUNDING.VENMO
        }).isEligible()

        setEligible(venmoEligible)
      } catch (error) {
        console.error("Error loading PayPal script or checking Venmo eligibility", error)
      }
    }

    checkEligibility()
    // Primitives, not sandboxProps — a fresh literal each render re-ran this.
  }, [ enabled, supported, clientId, sandbox, currency ])

  return { eligible, sandboxProps }
}

export default useVenmo
